export default class PageRefRegistrar {

    register(queryParams) {
        if (queryParams.ref) {
            window._paq.push(['trackEvent', 'Referral', 'Entry', queryParams.ref])
        }
    }

}



// WEBPACK FOOTER //
// ./src/system/PageRefRegistrar.js